export default __webpack_public_path__ + "static/casey-41e7b8e9b0b06e3b1ec56496b77f6367.svg";